import z from 'zod';
export const CountrySchema = z.object({
    id: z.number(),
    name: z.string(),
});
export const CountryListSchema = z.object({
    highlighted: z.array(CountrySchema).optional(),
    all: z.array(CountrySchema).optional()
});
//# sourceMappingURL=countrySchema.js.map